import Model from './Model'

export default class Device extends Model
{
    getFormAttributes() {
        const attributes = this.only(['name', 'description', 'serial'])
        attributes.person_id = this.used_by
        return attributes
    }

    static parseAttributes(attributes = {}) {
        attributes.person_id = attributes.person_id.value
        return attributes
    }

    static async all (query = null) {
        const config = { params: { query } }
        const { data } = await Http.get(route('api.v1.devices.index'), config)
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.devices.store')
        const { data } = await Http.post(url, this.parseAttributes(attributes))
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.devices.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, payload)
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.devices.destroy', this.id))
    }
}
